const messages = {
  es: {
    register: 'Registrarse',
    join_now: 'únase ahora',
    select_stream_below: 'Por favor, seleccione la secuencia preferida a continuación',
    please_write_your_question: 'Por favor, escriba sus preguntas',
    change: 'Cambiar',
    save: 'Guardar',
    cancel: 'Cancelar',
    send: 'Enviar',
    sending: 'Enviando...',
    name: 'Nombre',
    okey: 'Listo',
    city_or_country: 'Ciudad o País',
    please_register: 'Registrarse',
    please_wait: 'Por favor, espere',
    please_enter_your_name: 'Por favor, introduzca su nombre y ubicación antes de enviar una pregunta',
    hide_questions: 'Las preguntas solo son visibles para el locutor',
    add_to_calendar: 'Agregar al calendario',
    livecast_will_start_in: 'La transmisión en vivo comenzará {time}',
    form_validation_error: 'Error de validación',
    registration_form_error: 'Corrija los errores en el formulario de registro.',
    send_question_success: 'Su pregunta ha sido enviada.',
    send_question_error: '¡Error al enviar la pregunta!',
    required_field_error: 'This field is required',
    regform_selectBoxOther: 'Other',
    invalid_field_error: 'invalid {fieldName} format',
  }
}

export default messages